import { Navigate, useLocation } from "react-router-dom";
import { useAppContext } from "../../../contextApi/context";

function PrivateRoute({ children }) {
  const {
    store: { user },
  } = useAppContext();
  let decisionInput = useLocation();
  if (!user.isLogin) {
    switch (decisionInput.pathname) {
      case "/":
      case "/home":
      case "/login":
      case "/register":
      case "/forgotpassword":
        return children;
      default:
        return <Navigate to="/" />;
    }
  }
  if (user.isLogin) {
    switch (decisionInput.pathname) {
      case "/":
      case "/home":
      case "/login":
      case "/register":
      case "/forgotpassword":
        return <Navigate to={`/userpage/${user.id}`} />;
      default:
        return children;
    }
  }
}
export default PrivateRoute;
